import React, { useEffect } from 'react'
import SocketClient from '../Services/SocketClient';
import { useDispatch } from 'react-redux';
import { connectToSocket, disconnectFromSocket } from '../Store/socketSlice';
import { useSelector } from 'react-redux';

interface Props {
  children: any
}

export const socketClient = new SocketClient();

function LoggedInLayout({ children }: Props) {
  const dispatch = useDispatch();
  const { connectionStatus } = useSelector((state: any) => state.socket);
  
  useEffect(() => {
    // @ts-ignore
    dispatch(connectToSocket());
    
    return () => {
      // @ts-ignore
      if (connectionStatus === 'connected') {
        // @ts-ignore
        dispatch(disconnectFromSocket());
      }
    };
    //eslint-disable-next-line
  }, [dispatch]);

  return (
    <div>{children}</div>
  )
}

export default LoggedInLayout